// extracted by mini-css-extract-plugin
export default {"aboutArea":"techArea_aboutArea__e8MeC"};